// StepPayment / SquareCardForm 与保存逻辑（STEP_API['payment-method'].save）之间的桥。
// Square 卡表单是 hosted iframe，卡号不经过 antd Form，保存时必须找到「当前挂载的那个表单实例」
// 做 tokenize；三个宿主（向导 / Review 内联编辑 / Settings 弹窗）同一时刻只会挂载一个 StepPayment，
// 用模块级单例传递即可，不需要 context
export interface TokenizedCard {
    token: string;
    card: { brand: string; last4: string };
}

export const paymentBridge: {
    // SquareCardForm 挂载时注册：tokenize 当前卡表单；失败返回 null（错误已在表单内联展示）
    tokenize: (() => Promise<TokenizedCard | null>) | null;
    // StepPayment 挂载时注册：保存成功后把新卡写回表单（cardOnFile）并收起手动录卡态
    onSaved: ((card: { brand: string; last4: string }) => void) | null;
} = { tokenize: null, onSaved: null };

// Square brand 枚举（'VISA' / 'MASTERCARD' / ...）→ 展示名；
// tokenize details 与 GET /payment-methods 列表是同一套枚举，两处共用
export const squareBrandLabel = (b?: string) => {
    const up = String(b || '').toUpperCase();
    if (up === 'VISA') return 'Visa';
    if (up === 'MASTERCARD') return 'Mastercard';
    if (up === 'AMERICAN_EXPRESS') return 'Amex';
    if (up === 'DISCOVER') return 'Discover';
    return 'Card';
};
